module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6X7AL"))).then(() => parcelRequire('1iHdE'));